@if (configuration.display) {
<div class="item-container">
    @if (configuration?.showImage && data) {
    <figure>
        <!-- Item featured flags -->
        <ras-badges-container
            [data]="data"
            [configuration]="configuration?.childConfigs?.badges"
        ></ras-badges-container>
        <!-- Item primary image -->
        @if (data.image) {
        <img
            ras-image
            [transparent]="true"
            [id]="data.image"
            [alt]="getImgAltText(data)"
        />
        } @else {
        <img
            [src]="configuration?.defaultImage"
            [alt]="getImgAltText(data)"
            class="default-image"
        />
        }
    </figure>
    } @if (data) {
    <div class="content">
        <!-- Header -->
        <div class="content-header">
            <div class="content-header-inner">
                <!-- Title -->
                @if (configuration?.showTitle) {
                <div class="title">
                    @if (configuration?.itemTitle) {
                    {{ replaceTemplate(configuration.itemTitle, data) }}
                    <!-- Quantity -->
                    @if (configuration?.showQuantityAtHeader && data.quantity &&
                    !isLimitedSupply( data )) {
                    <span class="quantity-header">
                        {{ data.quantity | number }}
                    </span>
                    } } @else {
                    {{ data.year }} {{ data.make }} {{ data.model }}
                    }
                </div>
                }
                <!-- Location -->
                @if (configuration?.showLocation && ( data.branch_stat ||
                data.branch_city )) {
                <div class="location is-color-opacity-secondary">
                    {{ data.branch_city | lowercase }}, {{ data.branch_state }}
                </div>
                }
            </div>
            <!-- Price container -->
            @if (configuration?.showPrice) {
            <div class="price">
                @if (data.is_list_price_hidden || !data.list_price) {
                <div class="is-color-primary is-font-600">
                    <span>Contact for pricing</span>
                </div>
                } @if (!data.is_list_price_hidden && data.list_price) { @if
                (!configuration.showDiscountedPrice ||
                data.compare_at_price_multiplier <= 1) {
                <div class="is-color-primary is-font-600">
                    <span>{{ data.list_price | rasCurrency : data }}</span>
                </div>
                } @if (configuration.showDiscountedPrice &&
                data.compare_at_price_multiplier > 1) {
                <div class="is-color-primary is-font-600">
                    <span class="price-discount">
                        {{
                            getFormatted(
                                (
                                    data.list_price *
                                    data.compare_at_price_multiplier
                                ).toString(),
                                " - ",
                                "",
                                "money"
                            )
                        }}
                    </span>
                    <span class="price-raw">
                        {{ getFormatted(data.list_price, " - ", "", "money") }}
                    </span>
                </div>
                } @if (data.lowest_monthly_payment &&
                configuration?.showMonthlyPayment && isFinancingEnabled) {
                <div class="monthly-payment">
                    <strong
                        >{{
                            data.lowest_monthly_payment
                                | rasCurrency : data : false : true
                        }}
                        / mo</strong
                    >
                </div>
                } }
            </div>
            }
        </div>
        <!-- Details -->
        @if (configuration?.showDescription) {
        <div class="details">
            {{ data.detailed_description | ellipsis : 100 }}
        </div>
        }
        <!-- Footer -->
        <div class="content-footer">
            <!-- Meter -->
            @if (configuration?.showMeter && !!( data | rasMeter )) {
            <div class="meter is-color-opacity-secondary mr-2">
                <span>{{ data | rasMeter }}</span>
            </div>
            }
            <!-- data number -->
            @if (configuration?.showdataNumber) {
            <div class="data-id">
                <strong>data # </strong>
                <span>{{ data.data_number }}</span>
            </div>
            }
            <!-- data serial -->
            @if (configuration?.showdataSerial) {
            <div class="serial-id">
                <strong>Serial # </strong>
                <span>{{ data.serial_number }}</span>
            </div>
            }
            <!-- Quantity -->
            @if (configuration?.showQuantity && data.quantity &&
            !isLimitedSupply( data )) {
            <div
                class="quantity is-font-500"
                [class.low-items]="
                    configuration?.showQuantityLow
                        ? data.quantity <= configuration?.showQuantityLow
                        : false
                "
            >
                {{ data.quantity | number }} Available
            </div>
            }
            <!-- Price container -->
            @if (configuration?.showPriceFooter) {
            <div
                class="price price-footer-container"
                [class.limited-supply]="isLimitedSupply(data)"
            >
                @if (configuration?.labelPriceOnLowQuantity && isLimitedSupply(
                data )) {
                <div
                    class="is-color-primary is-font-600 label-price-low-quantity"
                    [innerHtml]="configuration?.labelPriceOnLowQuantity"
                ></div>
                } @else { @if (data.is_list_price_hidden || !data.list_price) {
                <div class="is-color-primary is-font-600">
                    <span>Contact for pricing</span>
                </div>
                } @if (!data.is_list_price_hidden && data.list_price) {
                <!-- Without discount -->
                @if (!configuration.showDiscountedPrice ||
                data.compare_at_price_multiplier <= 1) {
                <div>
                    @if (data.list_price) {
                    <div class="is-color-primary is-font-600">
                        <span class="price-raw">{{
                            data.list_price | rasCurrency : data : true
                        }}</span>
                    </div>
                    } @if (data.lowest_monthly_payment &&
                    configuration?.showMonthlyPayment && isFinancingEnabled) {
                    <div class="monthly-payment">
                        <strong
                            >{{
                                data.lowest_monthly_payment
                                    | rasCurrency : data : false : true
                            }}
                            /mo</strong
                        >
                    </div>
                    }
                </div>
                }
                <!-- With discount -->
                @if (configuration.showDiscountedPrice &&
                data.compare_at_price_multiplier > 1) {
                <div>
                    <span class="price-discount">
                        {{
                            getFormatted(
                                (
                                    data.list_price *
                                    data.compare_at_price_multiplier
                                ).toString(),
                                " - ",
                                "",
                                "money"
                            )
                        }}
                    </span>
                    <span class="price-raw">
                        {{ getFormatted(data.list_price, " - ", "", "money") }}
                    </span>
                    @if (data.lowest_monthly_payment &&
                    configuration?.showMonthlyPayment && isFinancingEnabled) {
                    <div class="monthly-payment">
                        <strong
                            >{{
                                data.lowest_monthly_payment
                                    | rasCurrency : data : false : true
                            }}
                            /mo</strong
                        >
                    </div>
                    }
                </div>
                } } }
            </div>
            }
            <!-- Likeable button -->
            @if (configuration?.showLikeable) {
            <fa-icon
                [class]="configuration?.isLiked ? 'fas' : 'far'"
                [icon]="[configuration?.isLiked ? 'fas' : 'far', 'heart']"
                (click)="
                    configuration.isLiked = onLike(!configuration?.isLiked)
                "
            >
            </fa-icon>
            }
        </div>
    </div>
    }
</div>
}
